import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { MEDIA } from "@/data/media";
import { Reveal } from "@/components/Reveal";

const STATS = [
  { value: "2026", label: "Est. Green Street" },
  { value: "500+", label: "Happy Customers" },
  { value: "200+", label: "Exclusive Pieces" },
  { value: "5.0", label: "Customer Rating", star: true },
];

export const About = () => (
  <section className="max-w-[1800px] mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20" data-testid="about-section">
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center">
      <Reveal className="lg:col-span-4">
        <img
          src={MEDIA.about}
          alt="Zebaa South Asian imitation jewellery - Green Street, London"
          className="w-full h-[360px] lg:h-[420px] object-cover"
        />
      </Reveal>

      <Reveal delay={0.1} className="lg:col-span-5">
        <p className="text-xs uppercase tracking-[0.28em] text-pink">About Zebaa</p>
        <h2 className="font-serif text-3xl lg:text-4xl mt-3 text-charcoal leading-tight">
          Where Tradition Meets Elegance
        </h2>
        <div className="w-16 h-px bg-gold mt-6" />
        <p className="text-gray-600 leading-relaxed mt-5 text-sm">
          Zebaa is a South Asian <span className="text-charcoal font-medium">imitation jewellery</span> shop
          on Green Street in East London - bridal sets, kundan-style necklaces, gold-tone bangles,
          earrings and chandbalis, carefully selected from partner workshops in Jaipur and Hyderabad.
          Everything we stock is imitation (artificial) jewellery - designed to look the part on the
          big day without the price tag of fine jewellery.
        </p>
        <Link
          to="/contact"
          data-testid="about-learn-more"
          className="inline-block border border-pink text-pink px-8 py-3.5 text-xs uppercase tracking-[0.18em] hover:bg-pink hover:text-white transition-colors duration-300 mt-7"
        >
          Learn More About Us
        </Link>
      </Reveal>

      <Reveal delay={0.2} className="lg:col-span-3">
        <div className="flex flex-row flex-wrap lg:flex-col gap-x-8 gap-y-6 lg:gap-6 lg:pl-8 lg:border-l lg:border-gray-200">
          {STATS.map((s) => (
            <div key={s.label} className="min-w-[80px]">
              <div className="font-sans font-semibold text-3xl lg:text-4xl text-metallic-gold flex items-center gap-1">
                {s.value}{s.star && <Star className="w-6 h-6 fill-current" strokeWidth={0} />}
              </div>
              <div className="text-[11px] uppercase tracking-[0.15em] text-gray-500 mt-1">{s.label}</div>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
